import React from 'react';
import { compose, withProps } from 'recompose';
import { TableRow, TableData } from '@scotia/canvas-react';
import { DataCard } from '../DataCard';
import style from './TableStore.scss';
import { CardContent } from '../Typography';

const CARD_BACKGROUND_COLOR = {
  WHITE: 'white',
  GRAY: '#FAFBFD'
};

const map = compose(
  withProps(({ row, mapping = identity => identity }) => mapping(row))
);
const render = (colRecord, { index, children }) => {
  return typeof children === 'function'
    ? children(colRecord[index])
    : colRecord[index];
};

const RowData = map(({ columns, isEver, isMobile, ...props }) => {
  const Row = isMobile ? React.Fragment : TableData;
  const children = columns.map(record => (
    <Row key={record.index}>
      <CardContent>{render(props, record)}</CardContent>
    </Row>
  ));
  return !!isMobile ? (
    <TableData style={{ padding: 0 }}>
      <div className={style['table-store']}>
        <DataCard
          styles={{
            backgroundColor: isEver
              ? CARD_BACKGROUND_COLOR.GRAY
              : CARD_BACKGROUND_COLOR.WHITE
          }}
        >
          {children}
        </DataCard>
      </div>
    </TableData>
  ) : (
    children
  );
});

export const TableStoreRows = (columns, mapping, rows, isMobile) =>
  rows &&
  rows.map((row, idx) => (
    <TableRow key={idx}>
      <RowData
        isEver={(idx + 1) % 2}
        row={row}
        mapping={mapping}
        columns={columns}
        isMobile={isMobile}
      />
    </TableRow>
  ));
